import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import OrderBookAddModalContainer from '../../../containers/projectmng/obtainorder/OrderBookAddModalContainer';
import OrderBookEditModalContainer from '../../../containers/projectmng/obtainorder/OrderBookEditModalContainer';
import OrderBookHistoryListContainer from '../../../containers/projectmng/obtainorder/OrderBookHistoryListContainer';
import * as chanceApi from '../../../lib/api/chance';
import {
  projectEstimateActive,
  projectOrderCount,
  setProject,
} from '../../../modules/projectModule/project';
import _ from 'lodash';
import { listProjectCosts } from '../../../modules/projectModule/projectCosts';
import AskDialog from '../../common/dialog/AskDialog';

const ObtainorderTemplate = ({ setActiveStep, setSelectedTab }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { project, activeEstimate, orderCount } = useSelector(
    ({ projectModule }) => ({
      project: projectModule.project.project,
      activeEstimate: projectModule.project.activeEstimate,
      orderCount: projectModule.project.orderCount,
    }),
  );

  const [type, setType] = useState('add');
  const [open, setOpen] = useState(false);
  const [roUuid, setRoUuid] = useState(null);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setRoUuid(null);
    setType('add');
    setOpen(false);
  };

  const editFunction = (param) => {
    setType('edit');
    setRoUuid(param.id);
    setOpen(true);
  };

  const handleAddOrder = () => {
    setType('add');
    setOpen(true);
  };

  const onCostUnLock = async () => {
    try {
      const res = await chanceApi.unDoCost(project.prjUuid);

      if (res.data.info) {
        dispatch(setProject(res.data.info));
        dispatch(listProjectCosts(project.prjUuid));
        dispatch(projectEstimateActive(project.prjUuid));
        dispatch(projectOrderCount(project.prjUuid));

        navigate('/chancemng');

        enqueueSnackbar('수주품의서를 재작성하십시오.', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
    onCostUnLock();
  };

  useEffect(() => {
    if (project) {
      dispatch(projectOrderCount(project.prjUuid));
      dispatch(projectEstimateActive(project.prjUuid));
    }
  }, [project]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <OrderBookHistoryListContainer editFunction={editFunction} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          py: 1,
        }}
      >
        <Button
          variant="contained"
          color="warning"
          onClick={() => setVisible(true)}
        >
          수주품의서 재작성
        </Button>
      </Box>
      <OrderBookEditModalContainer
        type={type}
        open={open}
        handleClose={handleClose}
        roUuid={roUuid}
      />
      <AskDialog
        visible={visible}
        title="프로젝트 수주품의서 재작성"
        description={`수주품의서를 재작성하시겠습니까?\r\n작업된(견적서 / 수주품의서 ) 등의 사항을 다시 작성해야 하며,\r\n 포캐스팅 리스트로 이동합니다.`}
        confirmText="수주품의서 재작성"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </Box>
  );
};

export default ObtainorderTemplate;
